import { Route, Switch } from "react-router-dom";
import "./../scss/WebHeliosen.scss";
import About from "./About";
import Business from "./Business";
import Ditap from "./Ditap";
import Promotion from "./Promotion";
import Recruit from "./Recruit";
import Footer from "./Footer";

function MainHeliosen() {
  return (
    <>
      <div className="container">
        <Switch>
          <Route path="/about" component={About} />
          <Route path="/business" component={Business} />
          <Route path="/ditap" component={Ditap} />
          <Route path="/promotion" component={Promotion} />
          <Route path="/recruit" component={Recruit} />
        </Switch>
      </div>
      <Footer />
    </>
  );
}

export default MainHeliosen;
